module.exports = __webpack_public_path__ + "img/enstsc_2.4d8288c9.png";